import React from "react";
import "./Footer.css";
import logo from "../../Assets/chef-set-logo.avif";
import { FaLinkedin } from "react-icons/fa";

import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <div>
      <footer className="footer">
        <div className="footer__container">
          <div className="footer_left">
            <div className="footer_logo_container">
              <img src={logo} alt="" z />
            </div>

            <p>
              Chef Set Ltd., Chefset House, 87 Brookvale Road, Witton BIRMINGHAM
              B6 7AR England
            </p>

            <div className="footer_address">
              <strong> sales@chefset.co.uk </strong>
              <strong> +44(0)121-356-6858 </strong>
              <strong> Mon-Fri 9am - 5pm </strong>
            </div>

            <div className="social_links">
              <Link
                to="https://www.linkedin.com/company/chefset/"
                target="_blank"
              >
                <FaLinkedin />
              </Link>
            </div>
          </div>

          <div className="footer_right catalogue_footer">
            <h5>Catalogue</h5>
            <p>
              <iframe
                title="Catalogue"
                allowFullScreen="allowfullscreen"
                className="fp-iframe"
                style={{
                  border: "0",
                  width: "100%",
                  height: "280px",
                }}
                src="https://heyzine.com/flip-book/e38bb5d703.html"
              ></iframe>
            </p>
          </div>

          {/* <div className="footer_content">
            <h5>Company</h5>
            <div className="links_container">
              <ul onClick={scrollToTop}>
                <li>
                  <Link to="/about">About Us</Link>
                </li>
                <li>
                  <Link to="/about">Career</Link>
                </li>
                <li>
                  <Link to="*">Affilates</Link>
                </li>
                <li>
                  <Link to="/blog">Blog</Link>
                </li>
                <li>
                  <Link to="/contact">Contact Us</Link>
                </li>
              </ul>
            </div>
          </div> */}
          {/* <div className="footer_content">
            <h5>Shop</h5>
            <div className="links_container">
              <ul onClick={scrollToTop}>
                <li>
                  <Link to="/shop">New Arrivals</Link>
                </li>
                <li>
                  <Link to="/shop">Accessories</Link>
                </li>
                <li>
                  <Link to="/shop">Men</Link>
                </li>
                <li>
                  <Link to="/shop">Women</Link>
                </li>
                <li>
                  <Link to="/shop">Shop All</Link>
                </li>
              </ul>
            </div>
          </div> */}
          {/* <div className="footer_content">
            <h5>Help</h5>
            <div className="links_container">
              <ul onClick={scrollToTop}>
                <li>
                  <Link to="/contact">Customer Service</Link>
                </li>
                <li>
                  <Link to="/auth">My Account</Link>
                </li>
                <li>
                  <Link to="/contact">Find a Store</Link>
                </li>
                <li>
                  <Link to="/terms">Legal & Privacy</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
                <li>
                  <Link to="/">Gift Card</Link>
                </li>
              </ul>
            </div>
          </div> */}
          {/* <div className="footer_right">
            <h5>Subscribe</h5>
            <p>
              Be the first to get the latest news about trends, promotions, and
              much more!
            </p>

            <form onSubmit={handleSubscribe}>
              <input type="email" placeholder="Your email address" required />
              <button type="submit">Join</button>
            </form>

            <h6>Secure Payments</h6>
            <div className="paymentIconContainer">
              <img src={paymentIcon} alt="" />
            </div>
          </div> */}
        </div>
        <div className="footer_bottom">
          <p>© {currentYear} Chef Set. All Rights Reserved</p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
